module.exports = __webpack_public_path__ + "static/media/gi.48b4bc3c.webm";